export default "__VITE_ASSET__dpLvwqQn__"